import React from "react"
import Icon from "@kit/design/icon"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { useEditing } from "app/regions/hooks/use-editing"
import { getTemplate } from "./utils"
import { InheritedThemeProvider } from "@convertkit/editor"
import { Block } from "../shared/block"
import { WrapperBlockToolbar } from "./components/wrapper-block-toolbar"
import "./layout.css"

const styleOverride = `
  .ck-layout-block h1,
  .ck-layout-block h2,
  .ck-layout-block h3,
  .ck-layout-block h4,
  .ck-layout-block h5,
  .ck-layout-block h6,
  .ck-layout-block p,
  .ck-layout-block ul,
  .ck-layout-block ol,
  .ck-layout-block li {
    margin: 0 !important;
    padding: 0 !important;
  }

  .ck-layout-block p {
    margin: 8px 0 !important;
  }
`

// This component is rendered when there isn't a layout selected.
function Placeholder() {
  const editing = useEditing()

  if (!editing) return null

  return (
    <div className="font-sans py-8 px-4 my-5 border rounded bg-white flex items-center justify-center flex-col font-semibold cursor-pointer">
      <Icon name="layout-masonry" className="w-16 h-16 mb-2 text-gray-700" />
      Select a Layout in the sidebar
    </div>
  )
}

function ThemeWrapper({ properties, children }) {
  const theme = {
    h1: {
      color: properties.headingColor,
      fontFamily: properties.headingFontFamily,
      fontWeight: properties.headingFontWeight
    },
    h2: {
      color: properties.headingColor,
      fontFamily: properties.headingFontFamily,
      fontWeight: properties.headingFontWeight
    },
    h3: {
      color: properties.headingColor,
      fontFamily: properties.headingFontFamily,
      fontWeight: properties.headingFontWeight
    },
    h4: {
      color: properties.headingColor,
      fontFamily: properties.headingFontFamily,
      fontWeight: properties.headingFontWeight
    },
    h5: {
      color: properties.headingColor,
      fontFamily: properties.headingFontFamily,
      fontWeight: properties.headingFontWeight
    },
    h6: {
      color: properties.headingColor,
      fontFamily: properties.headingFontFamily,
      fontWeight: properties.headingFontWeight
    },
    paragraph: {
      color: properties.textColor,
      fontFamily: properties.textFontFamily,
      fontWeight: properties.textFontWeight
    }
  }

  return (
    <InheritedThemeProvider theme={theme}>{children}</InheritedThemeProvider>
  )
}

// This is the shell for layout blocks. It renders the selected template (such
// as "CTALeftImageRight") inside of an element that can be clicked to focus
// the block. This will render in both the editor and the serialized email.
export function Layout({ id }) {
  const { block, properties } = useBlocks(id)
  const EditorComponent = getTemplate(properties.template)?.EditorComponent

  return (
    <ThemeWrapper properties={properties}>
      <Block
        style={{
          marginTop:
            properties.marginTop === undefined ? 18 : properties.marginTop,
          marginBottom:
            properties.marginBottom === undefined
              ? 18
              : properties.marginBottom,
          cursor: "auto"
        }}
        className="ck-layout-block relative"
        id={id}
      >
        <WrapperBlockToolbar block={block}>
          {properties.template ? (
            <EditorComponent block_id={id} properties={properties} />
          ) : (
            <Placeholder />
          )}
          <style>{styleOverride}</style>
        </WrapperBlockToolbar>
      </Block>
    </ThemeWrapper>
  )
}
